import { css } from '@microsoft/fast-element';
export const foundationDatePickerStyles = css `
  :host {
    position: relative;
  }

  .date-toggle::part(control) {
    cursor: pointer;
  }

  .date-toggle::part(label) {
    cursor: pointer;
  }

  .calendar-dropdown {
    display: none;
    width: 300px;
    z-index: 999;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 8px);
    margin: 10px 0 0;
    padding: 20px;
    background: var(--neutral-foreground-rest);
    border-radius: calc(var(--control-corner-radius) * 1px);
    box-shadow: 0 0 8px rgb(0 0 0 / 20%);
  }

  .calendar-dropdown.top {
    top: auto;
    bottom: 100%;
    margin: 0 0 5px;
    transform: translate(-50%, -8px);
  }

  .calendar-dropdown.left {
    top: 50%;
    left: 0;
    margin: 0 0 0 5px;
    transform: translate(calc(-8px + -100%), -50%);
  }

  .calendar-dropdown.right {
    top: 50%;
    left: 100%;
    transform: translate(8px, -50%);
  }

  .calendar-dropdown.visible {
    display: block;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 10px;
  }

  .header h3 {
    margin: 0;
    text-transform: capitalize;
    font-weight: bold;
    color: var(--foreground-on-accent-rest);
  }

  .header .months-arrows {
    display: flex;
    flex-direction: row;
  }

  .header .icon-container {
    display: flex;
    width: 25px;
    height: 25px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .header .icon-container:first-child {
    margin-right: calc(var(--design-unit) * 2px);
  }

  .header .prev-month,
  .header .next-month {
    color: var(--foreground-on-accent-rest);
    font-size: 18px;
  }

  .week-days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 5px;
    margin-bottom: 10px;
    color: var(--foreground-on-accent-rest);
  }

  .week-days span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    text-transform: capitalize;
  }

  .month-days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-gap: 5px;
  }

  .month-day {
    padding: 8px 5px;
    color: #808080;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(var(--control-corner-radius) * 4px);
    cursor: pointer;
    border: none;
  }

  .month-day.current {
    opacity: 100%;
    color: var(--foreground-on-accent-rest);
  }

  .month-day.selected {
    background: var(--accent-foreground-rest);
    color: var(--neutral-foreground-rest);
  }

  .month-day:hover {
    background: var(--neutral-stroke-hover);
    color: (--neutral-foreground-rest);
  }

  .date-toggle[readonly] .label {
    cursor: pointer;
  }
`;
